export default {
      id: "toolbar_queries-usage",
      viewBox: "0 0 18 18",
      url: "assets/" + "sprite.svg#toolbar_queries-usage",
      toString: function () {
        return this.url;
      }
    }